// @ts-nocheck

export const localeCodes =  [
  "en",
  "ms-my"
]
export const localeLoaders = {
  en: [],
  "ms-my": []
}
export const vueI18nConfigs = []
export const normalizedLocales = [
  {
    code: "en",
    language: "en-US",
    name: "English",
    domains: [],
    defaultForDomains: []
  },
  {
    code: "ms-my",
    language: "ms-MY",
    name: "Bahasa Melayu",
    domains: [],
    defaultForDomains: []
  }
]

